import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Typography, Col, Row, Tooltip, Spin } from 'antd';
import styles from '../../../../shared-components/Recipe/recipe.module.sass';
import { default as threat_detail_styles } from '../../../HomeContainer/components/Home/threat-detail.module.sass';
import { InfoCircleFilled } from '@ant-design/icons';
import mixpanel from 'mixpanel-browser';
import history from '../../../../redux/history';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';
import { useDispatch } from 'react-redux';
import SavedRecipeModal from '../../../../shared-components/SavedRecipeModal';
import useModalNameValidator from '../../../../redux/utils/useModalNameValidator';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { highlightLeftMenu } from '../../../../redux/actions/leftMenu';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { ResponsiveBar } from '@nivo/bar';
import { validateRecipeDomainName } from '../../../../shared-components/Validation/RecipeDomainName';

function DanglingDNSRecordsCountQuery(props) {
  mixpanel.track('Global Nav - Dangling DNS Records Count', {
    location: window.location.href,
  });
  const {
    exploreRecipeDanglingDNSRecordsCount,
    recipeDataStatusDanglingDNSRecordsCount,
    exploreRecipeDataDanglingDNSRecordsCount,
    clearRecipe,
    unsetClearRecipe,
  } = props;

  const barchartData = [
    {
      actionType: 'Danglers Unchanged',
      NS: 0,
      MX: 0,
      CNAME: 0,
    },
    {
      actionType: 'Danglers Added',
      NS: 0,
      MX: 0,
      CNAME: 0,
    },
    {
      actionType: 'Danglers Removed',
      NS: 0,
      MX: 0,
      CNAME: 0,
    },
  ];
  const baseBarchartColumns = [
    {
      actionType: 'Danglers Unchanged',
      NS: 0,
      MX: 0,
      CNAME: 0,
    },
    {
      actionType: 'Danglers Added',
      NS: 0,
      MX: 0,
      CNAME: 0,
    },
    {
      actionType: 'Danglers Removed',
      NS: 0,
      MX: 0,
      CNAME: 0,
    },
  ];

  const q = useQuery();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [nameOfNewQuery, setNameOfNewQuery] = useState('');
  const [descriptionOfNewQuery, setDescriptionOfNewQuery] = useState('');
  const [saveModalType, setSaveModalType] = useState('saveNew');
  const isSaveModalValid = useModalNameValidator(nameOfNewQuery);
  const { Paragraph, Text, Title } = Typography;
  const titleText = q?.get('left_menu_name') || 'Dangling DNS Records Count';
  const threatNameValue = Form.useWatch('threat_name', form);
  const [barchartColumns, setBarchartColumns] = useState(baseBarchartColumns);
  const [barchartDataUnavailable, setBarchartDataUnavailable] = useState(false);
  const [searchHappened, setSearchHappened] = useState(false);

  useEffect(() => {
    document.title = `${titleText} - Silent Push`;
    props.loadUser();
    props.loadMySubscriptionPlan();
    props.resetRecipeStatus();
    props.clearExploreDetails();
    form.resetFields();
    setBarchartColumns(baseBarchartColumns);
    setBarchartDataUnavailable(false);
    setSearchHappened(false);

    if (q?.get('recipeid')) {
      //load specific recipe
      props.loadMergeAPIExploreRecipeDanglingDNSRecordsCount(
        q?.get('recipeid'),
      );
    }
    dispatch(changeTitle(titleText, null));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.resetRecipeStatus();
    form.resetFields();
    setSaveModalType('saveNew');

    setBarchartColumns(baseBarchartColumns);
    setBarchartDataUnavailable(false);
    setSearchHappened(false);

    if (q?.get('recipeid')) {
      //load specific recipe
      props.loadMergeAPIExploreRecipeDanglingDNSRecordsCount(
        q?.get('recipeid'),
      );
    }
  }, [window.location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (clearRecipe === true) {
      document.title = `${titleText} - Silent Push`;
      props.clearExploreDetails();
      // props.saveBreadCrumbs(null);
      props.loadUser();
      props.loadMySubscriptionPlan();
      props.resetRecipeStatus();
      props.clearExploreDetails();
      form.resetFields();
      // recipeInitCollapse();
      // setSearchQuery('');
      props.unsetClearRecipe();
    }
  }, [clearRecipe]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(
      changeTitle(
        props?.exploreRecipeDanglingDNSRecordsCount?.name ?? titleText,
        null,
      ),
    );
    document.title = `${titleText} - Silent Push`;
    if (
      props.recipeStatusDanglingDNSRecordsCount == STATUS.LOADED &&
      props?.exploreRecipeDanglingDNSRecordsCount?.name
    ) {
      document.title = `${props?.exploreRecipeDanglingDNSRecordsCount?.name} - Silent Push`;
    }

    if (window.location.href.includes('/explore/dangling-dns-records-count')) {
      if (
        props?.exploreRecipeDanglingDNSRecordsCount?.uuid &&
        window.location.href.indexOf(
          '/explore/dangling-dns-records-count?recipeid=' +
            props?.exploreRecipeDanglingDNSRecordsCount?.uuid,
        ) == -1
      ) {
        history.push(
          '/explore/dangling-dns-records-count?recipeid=' +
            props?.exploreRecipeDanglingDNSRecordsCount?.uuid,
        );
        dispatch(
          highlightLeftMenu(props?.exploreRecipeDanglingDNSRecordsCount?.uuid),
        );
      }
      form.resetFields();
      setBarchartColumns(baseBarchartColumns);
      setBarchartDataUnavailable(false);
      setSearchHappened(false);
      form.setFieldsValue({
        threat_name: exploreRecipeDanglingDNSRecordsCount?.domain,
        type: exploreRecipeDanglingDNSRecordsCount?.query_type,
        window: exploreRecipeDanglingDNSRecordsCount?.window,
      });
    }
  }, [props.exploreRecipeDanglingDNSRecordsCount]);

  useEffect(() => {
    if (
      exploreRecipeDataDanglingDNSRecordsCount?.response?.records?.length > 0
    ) {
      const records = exploreRecipeDataDanglingDNSRecordsCount.response.records;
      let dataArray = barchartData;

      for (let i in records) {
        if (records[i]?.danglers_unchanged) {
          switch (records[i]?.danglers_unchanged?.type) {
            case 'NS':
              dataArray[0].NS = records[i]?.danglers_unchanged?.count;
            case 'MX':
              dataArray[0].MX = records[i]?.danglers_unchanged?.count;
            case 'CNAME':
              dataArray[0].CNAME = records[i]?.danglers_unchanged?.count;
          }
        }
        if (records[i]?.danglers_added) {
          switch (records[i]?.danglers_added?.type) {
            case 'NS':
              dataArray[1].NS = records[i]?.danglers_added?.count;
            case 'MX':
              dataArray[1].MX = records[i]?.danglers_added?.count;
            case 'CNAME':
              dataArray[1].CNAME = records[i]?.danglers_added?.count;
          }
        }
        if (records[i]?.danglers_removed) {
          switch (records[i]?.danglers_removed?.type) {
            case 'NS':
              dataArray[2].NS = records[i]?.danglers_removed?.count;
            case 'MX':
              dataArray[2].MX = records[i]?.danglers_removed?.count;
            case 'CNAME':
              dataArray[2].CNAME = records[i]?.danglers_removed?.count;
          }
        }
      }

      setBarchartDataUnavailable(false);
      setSearchHappened(false);
      setBarchartColumns(dataArray);
    } else if (
      recipeDataStatusDanglingDNSRecordsCount === STATUS.LOADED &&
      searchHappened
    ) {
      setBarchartDataUnavailable(true);
      setBarchartColumns(baseBarchartColumns);
    }
  }, [exploreRecipeDataDanglingDNSRecordsCount]);

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  function resetForm() {
    form.resetFields();
    setBarchartColumns(baseBarchartColumns);
    setBarchartDataUnavailable(false);
    setSearchHappened(false);
    props.resetRecipeStatus();
    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeDanglingDNSRecordsCount(
        q?.get('recipeid'),
      );
    }
  }

  const handleCancel = () => {
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  function changeScopeRecipe() {
    props.changeScopeMergeAPIExploreRecipeDanglingDNSRecordsCount({
      scope:
        props?.exploreRecipeDanglingDNSRecordsCount?.scope === 'USER'
          ? 'ORGANISATION'
          : 'USER',
      uuid: props?.exploreRecipeDanglingDNSRecordsCount?.uuid,
    });
  }

  function returnUiRecipeData(values, type) {
    if (type === 'saveAs') {
      return {
        new_name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeDanglingDNSRecordsCount?.name,
        new_description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeDanglingDNSRecordsCount?.description,
      };
    } else {
      return {
        name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeDanglingDNSRecordsCount?.name,
        description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeDanglingDNSRecordsCount?.description,
        domain: values?.threat_name,
        uuid: q?.get('recipeid'),
      };
    }
  }

  const handleOk = (type) => {
    form
      .validateFields()
      .then((values) => {
        if (saveModalType === 'edit' || type === 'edit') {
          props.updateMergeAPIExploreRecipeDanglingDNSRecordsCount(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveNew' || type === 'saveNew') {
          props.saveMergeAPIExploreRecipeDanglingDNSRecordsCount(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveAs' || type === 'saveAs') {
          props.cloneRecipe(
            returnUiRecipeData(values, type),
            'dangling-dns-records-count-recipes',
            q?.get('recipeid'),
          );
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  function renderPane() {
    return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
      props.mySubscriptionPlan
        ?.has_access_to_dangling_dns_records_count_recipe ? (
        props.recipeStatusDanglingDNSRecordsCount !== STATUS.LOADING ? (
          <div className={styles.explore_recipe}>
            <Row gutter={24}>
              <Col xs={24} className={styles.header}>
                <div className={threat_detail_styles['type-chip']}>
                  {titleText}
                </div>

                <div className={styles.recipeDescription}>
                  <Paragraph className="m-0">
                    {exploreRecipeDanglingDNSRecordsCount?.description
                      ? exploreRecipeDanglingDNSRecordsCount.description
                      : 'Get a report with counts of dangling DNS records.'}{' '}
                  </Paragraph>

                  <Link
                    to={{
                      pathname:
                        'https://help.silentpush.com/docs/get-a-dangling-dns-record-count',
                    }}
                    target="_blank"
                  >
                    Knowledge Base
                  </Link>
                </div>

                <div className={styles.action_buttons}>
                  {((q?.get('recipeid') &&
                    props?.exploreRecipeDanglingDNSRecordsCount?.scope ===
                      'USER') ||
                    (q?.get('recipeid') &&
                      props?.exploreRecipeDanglingDNSRecordsCount?.scope ===
                        'ORGANISATION' &&
                      props?.exploreRecipeDanglingDNSRecordsCount?.is_mine ===
                        true)) && (
                    <>
                      <Tooltip
                        title={
                          props.mySubscriptionPlan
                            ?.has_access_to_share_unshare ? (
                            ''
                          ) : (
                            <>
                              Sharing option is not part of this subscription
                              plan. To upgrade your subscription contact us at{' '}
                              <a
                                target="_blank"
                                href="mailto:sales@silentpush.com"
                              >
                                sales@silentpush.com
                              </a>
                              .
                            </>
                          )
                        }
                      >
                        <Button
                          disabled={
                            !props.mySubscriptionPlan
                              ?.has_access_to_share_unshare
                          }
                          role={'button1'}
                          onClick={() => changeScopeRecipe()}
                        >
                          {props?.exploreRecipeDanglingDNSRecordsCount
                            ?.scope === 'ORGANISATION'
                            ? 'Unshare'
                            : 'Share'}
                        </Button>
                      </Tooltip>

                      <Button
                        onClick={() => {
                          setSaveModalType('edit');
                          setIsModalVisible(true);
                        }}
                      >
                        Edit
                      </Button>

                      <Button
                        danger
                        onClick={() => {
                          props.deleteMergeAPIExploreRecipeDanglingDNSRecordsCount(
                            q?.get('recipeid'),
                          );
                          props.resetRecipeStatus();
                          props.clearExploreDetails();
                          props.history.push('/explore');
                        }}
                      >
                        Delete
                      </Button>
                    </>
                  )}
                </div>
              </Col>
            </Row>

            <Form
              className={styles.form}
              form={form}
              name="explore"
              initialValues={{
                threat_name: exploreRecipeDanglingDNSRecordsCount?.domain,
                type: exploreRecipeDanglingDNSRecordsCount?.query_type,
                window: exploreRecipeDanglingDNSRecordsCount?.window,
              }}
              onFinish={(values) => {
                if (values?.threat_name) {
                  setSearchHappened(true);
                  props.loadDanglingDNSRecordsCountData({
                    path: decodeURIComponent(
                      `padns%2Flookup%2Freport%2Fdanglerscount%3Fdomain%3D${values?.threat_name}%26origin_uid%3DDANGLING_DNS_RECORD_COUNT%26is_visualizable%3D1`,
                    ),
                  });
                }
              }}
            >
              <Row gutter={36}>
                <Col xs={24}>
                  <Title level={5}>
                    Domain *{' '}
                    <Tooltip
                      placement="top"
                      title="Enter a domain name of the source record. Wildcards are not supported"
                    >
                      <InfoCircleFilled />
                    </Tooltip>
                  </Title>
                </Col>

                <Col xs={24} lg={12}>
                  <Text>Domain Name</Text>
                  <div className={styles.domain_reset}>
                    <Form.Item
                      name="threat_name"
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(fieldObject, fieldValue) {
                            const validation = validateRecipeDomainName(
                              fieldValue,
                              titleText,
                            );

                            if (validation.valid) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject(validation?.message);
                            }
                          },
                        }),
                      ]}
                    >
                      <Input maxLength={255} placeholder="Enter Domain Name" />
                    </Form.Item>
                  </div>

                  <div className={styles.bottom_actions}>
                    <Form.Item>
                      <Tooltip
                        title={
                          props.mySubscriptionPlan?.has_access_to_explore ? (
                            ''
                          ) : (
                            <>
                              This option is not part of this subscription plan.
                              To upgrade your subscription contact us at{' '}
                              <a
                                target="_blank"
                                href="mailto:sales@silentpush.com"
                              >
                                sales@silentpush.com
                              </a>
                              .
                            </>
                          )
                        }
                      >
                        <Button
                          role={'button2'}
                          type="primary"
                          htmlType="submit"
                          disabled={
                            !(threatNameValue?.length > 0) ||
                            !props.mySubscriptionPlan?.has_access_to_explore
                          }
                        >
                          Search
                        </Button>
                      </Tooltip>
                    </Form.Item>

                    <Button
                      role={'button1'}
                      disabled={!(threatNameValue?.length > 0)}
                      onClick={() => {
                        if (
                          saveModalType === 'saveNew' &&
                          !q?.get('recipeid')
                        ) {
                          setNameOfNewQuery('');
                          setDescriptionOfNewQuery('');
                          setSaveModalType('saveNew');
                          setIsModalVisible(true);
                        } else {
                          handleOk('edit');
                        }
                      }}
                    >
                      {q?.get('recipeid') ? 'Update Recipe' : 'Save Recipe'}
                    </Button>

                    {q?.get('recipeid') && (
                      <Button
                        role={'button3'}
                        onClick={() => {
                          setSaveModalType('saveAs');
                          setIsModalVisible(true);
                        }}
                      >
                        Save As
                      </Button>
                    )}

                    <Button className="ms-05" onClick={() => resetForm()}>
                      Reset Form
                    </Button>
                  </div>
                </Col>

                <Col xs={24} lg={12}>
                  <div
                    className={cx(styles.danglingDnsChartContainer, {
                      [styles.noData]: barchartDataUnavailable,
                    })}
                  >
                    <ResponsiveBar
                      data={barchartColumns}
                      groupMode="grouped"
                      keys={['NS', 'MX', 'CNAME']}
                      indexBy="actionType"
                      margin={{ top: 32, right: 0, bottom: 32, left: 32 }}
                      padding={0.3}
                      innerPadding={4}
                      valueScale={{ type: 'linear' }}
                      indexScale={{ type: 'band', round: true }}
                      colors={['#3C9AE8', '#b686ab', '#f0624a']}
                      borderColor={{
                        from: 'color',
                        modifiers: [['darker', 1.6]],
                      }}
                      axisTop={null}
                      axisRight={null}
                      axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legendPosition: 'middle',
                        legendOffset: 32,
                        truncateTickAt: 0,
                      }}
                      axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legendPosition: 'middle',
                        legendOffset: -40,
                        truncateTickAt: 0,
                      }}
                      labelSkipWidth={12}
                      labelSkipHeight={12}
                      labelTextColor={{
                        from: 'color',
                        modifiers: [['darker', 1.6]],
                      }}
                      role="application"
                      ariaLabel="Dangling DNS Records Count chart"
                      barAriaLabel={(e) =>
                        e.id +
                        ': ' +
                        e.formattedValue +
                        ' action type: ' +
                        e.indexValue
                      }
                      legends={[
                        {
                          dataFrom: 'keys',
                          anchor: 'top',
                          direction: 'row',
                          justify: false,
                          translateX: 0,
                          translateY: -30,
                          itemsSpacing: 10,
                          itemWidth: 50,
                          itemHeight: 20,
                          itemDirection: 'left-to-right',
                          itemOpacity: 0.85,
                          symbolSize: 20,
                          effects: [
                            {
                              on: 'hover',
                              style: {
                                itemOpacity: 1,
                              },
                            },
                          ],
                        },
                      ]}
                    />
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        ) : (
          <LoadingSilentPush size={80} positionCenter />
        )
      ) : (
        <PermissionDeniedPage />
      )
    ) : (
      <LoadingSilentPush size={80} positionCenter />
    );
  }

  return (
    <>
      <SavedRecipeModal
        isModalVisible={isModalVisible}
        isSaveModalValid={isSaveModalValid}
        handleOk={handleOk}
        handleCancel={handleCancel}
        nameOfNewQuery={nameOfNewQuery}
        setNameOfNewQuery={setNameOfNewQuery}
        descriptionOfNewQuery={descriptionOfNewQuery}
        setDescriptionOfNewQuery={setDescriptionOfNewQuery}
        type={saveModalType}
        loadedRecipe={exploreRecipeDanglingDNSRecordsCount}
      />
      {renderPane()}
      <VersionCheck
        parentComponentStatus={
          q?.get('recipeid')
            ? props.recipeStatusDanglingDNSRecordsCount
            : STATUS.LOADED
        }
      />
    </>
  );
}

export default DanglingDNSRecordsCountQuery;
